import { render, staticRenderFns } from "./groupTrendChart.vue?vue&type=template&id=10348594&"
import script from "./groupTrendChart.vue?vue&type=script&lang=js&"
export * from "./groupTrendChart.vue?vue&type=script&lang=js&"
import style0 from "./groupTrendChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports